export const GIFTED_STAT_DESCRIPTION =
  'Gift Cards given by this user that were redeemed.';

export function giftedListPath(channel: string): string {
  return `/u/${encodeURIComponent(channel)}/gifted`;
}

export function formatGiftedStat(value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  if (!Number.isFinite(value) || value < 0 || !Number.isInteger(value)) return '—';
  return new Intl.NumberFormat().format(value);
}
